import React from 'react';

import { useNavigate } from 'react-router-dom';

import { ARROW_RIGHT_ICON } from '../../../../constants/images';
import { CLICK_ACTION, MAIN_BANNER } from '../../../../constants/tagManager';
import { BdsBannerLayoutProps } from '../../../../interfaces/bdsBanner';
import TagManagerService from '../../../../services/gtm/tagManagerService';
import { redirectToPage } from '../../../../utils/utils';
import BdsLabelPill from '../../BdsLabelPill/BdsLabelPill';
import BdsStepsIndicator from '../../BdsStepsIndicator/BdsStepsIndicator';
import BdsButton from '../../Buttons/BdsButton/BdsButton';

const BdsBannerLayout = ({ banner, position, total, setSlide }: BdsBannerLayoutProps) => {
  const { id, title, description, callToAction, backgroundColor, contentUrl, label } = banner;

  const gtmParams = {
    banner_id: id,
    banner_url: callToAction?.route,
    position
  };

  const navigate = useNavigate();

  const handleClick = () => {
    TagManagerService.pushEvent(CLICK_ACTION, MAIN_BANNER, gtmParams);
    redirectToPage(navigate, callToAction?.route);
  };

  const renderLabel = () => {
    if (label) {
      return <BdsLabelPill text={label} variant="accent" color="accent-tertiary" />;
    }
  };

  const renderButton = () => {
    if (callToAction) {
      return (
        <BdsButton variant={buttonVariant} action={handleClick} size="s" iconRight={ARROW_RIGHT_ICON}>
          {callToAction.text}
        </BdsButton>
      );
    }
  };

  const existsImage = contentUrl != null;
  const backgroundStyle = existsImage
    ? {
        backgroundImage: `linear-gradient(to bottom, rgba(217, 217, 217, 0), rgba(0, 0, 0, 1)), url(${contentUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }
    : {
        backgroundColor: backgroundColor
      };
  const containerClassName = existsImage ? 'bds-banner-container' : 'bds-banner-container no-image';
  const bannerInfoClassName = existsImage ? 'bds-banner-info' : 'bds-banner-info no-image';
  const buttonVariant = existsImage ? 'inverse' : 'primary';
  const stepIndicatorVariant = existsImage ? 'accent' : 'primary';

  return (
    <div className={containerClassName} style={backgroundStyle}>
      <div className="bds-banner-content">
        <div className={bannerInfoClassName}>
          {renderLabel()}
          <p className={'bds-banner-title'}>{title}</p>
          <p className={`bds-banner-description ${label ? 'label' : ''}`}>{description}</p>
        </div>
        <div className="bds-banner-row">
          <BdsStepsIndicator
            steps={total || 1}
            active={position - 1}
            variant={stepIndicatorVariant}
            changeStep={setSlide}
          />
          {renderButton()}
        </div>
      </div>
    </div>
  );
};

export default BdsBannerLayout;
